<template>
  <b-card>
    <b-card-header>
      <h4 class="title">
        لیست درخواست رزرو اتاق
      </h4>
    </b-card-header>
    <b-card-body>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          variant="success"
          class="mb-1 float-right"
          target="_blank"
          :href="exportExcel"
      >
        <feather-icon
            icon="FileTextIcon"
            class="mr-50"
        />
        <span class="align-middle">خروجی اکسل</span>
      </b-button>
      <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.filter-box
          variant="outline-primary"
          class="mb-1"
      >
        <feather-icon
            icon="FilterIcon"
            class="mr-50"
        />
        <span class="align-middle">جستجو</span>
      </b-button>
      <b-collapse
          id="filter-box"
          class="mb-2"
      >
        <b-card class="border mb-0">
          <b-form @submit.prevent>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label>شماره درخواست :</label>
                  <b-form-input
                      v-model="search.id"
                      placeholder="شماره درخواست را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label>متن شامل:</label>
                  <b-form-input
                      v-model="search.description"
                      placeholder="بخشی از توضیحات را وارد نمایید."
                      type="text"
                      class="d-inline-block"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label for="role">
                    درخوست دهنده
                  </label>
                  <v-select
                      v-model="search.requester"
                      dir="rtl"
                      label="name"
                      :options="receiversList"
                      :reduce="member => member.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>

              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label for="role">
                    نام اتاق
                  </label>
                  <v-select
                      v-model="search.room"
                      multiple
                      dir="rtl"
                      label="name"
                      :options="roomList"
                      :reduce="room => room.id"
                      :filterable="false"
                      @search="onSearch"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                    label="جلسات از تاریخ"
                    label-for="meetingFrom"
                >
                  <date-picker
                      v-model="search.meetingFrom"
                      type="datetime"
                      display-format="jDD jMMMM jYYYY HH:mm"
                      format="YYYY-MM-DD HH:mm"
                      :max="search.meetingTo"
                      clearable
                  />

                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                    label="جلسات تا تاریخ"
                    label-for="meetingTo"
                >
                  <date-picker
                      v-model="search.meetingTo"
                      type="datetime"
                      display-format="jDD jMMMM jYYYY HH:mm"
                      format="YYYY-MM-DD HH:mm"
                      :min="search.meetingFrom"
                      clearable
                  />

                </b-form-group>
              </b-col>
            </b-row>
            <b-row>

              <b-col md="12">
                <b-form-group>
                  <div class="demo-inline-spacing">
                    <label for="role">
                      وضعیت نهایی درخواست:
                    </label>
                    <b-form-radio
                        v-model="search.status"
                        name="task-status"
                        value=""
                    >
                      همه
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.status"
                        name="task-status"
                        value="PENDING"
                    >
                      در انتظار بررسی
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.status"
                        name="task-status"
                        value="ACCEPTED"
                    >
                      تأیید شده
                    </b-form-radio>

                    <b-form-radio
                        v-model="search.status"
                        name="task-status"
                        value="REJECTED"
                    >
                      رد شده
                    </b-form-radio>
                    <b-form-radio
                        v-model="search.status"
                        name="task-status"
                        value="CANCELED"
                    >
                      لغو شده
                    </b-form-radio>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <hr>
            <div class="demo-inline-spacing">
              <b-button
                  type="submit"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="primary"
                  @click="advanceSearch"
              >
                اعمال جستجو
              </b-button>
              <b-button
                  type="button"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-secondary"
                  @click="clearSearch"
              >
                حذف فیلترها
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-collapse>
      <b-overlay :show="onProgress">
        <div ref="resultTable">
          <b-table
            :fields="fields"
            :items="items"
            hover
            striped
            responsive
          >
            <template #table-busy>
              <div class="text-center text-info my-2">
                <b-spinner class="align-middle" />
                <strong> درحال دریافت اطلاعات...</strong>
              </div>
            </template>

            <template #cell(date)="data">
              {{ data.item.startAt}}  الی  {{ data.item.endAt}}
            </template>
            <template #cell(status)="data">
              <b-badge
                  :variant="data.value.label"
                  class="mr-1"
              >
                {{ data.value.title }}
              </b-badge>
            </template>
            <template #cell(action)="data">
              <b-dropdown
                text="عملیات"
                variant="outline-primary"

              >
                <b-dropdown-item @click="getDetail(data.item.id)">
                  <feather-icon
                    icon="EyeIcon"
                    class="text-info"
                  />
                  مشاهده
                </b-dropdown-item>
                <b-dropdown-item v-if="data.item.status.key === 'PENDING'" :to="{name: 'RoomReservation_AdminEdit', params:{id: data.item.id}}">
                  <feather-icon
                    icon="EditIcon"
                    class="text-warning"
                  />
                  ویرایش
                </b-dropdown-item>
                <b-dropdown-item v-if="data.item.status.key === 'PENDING'" @click="deleteRequest(data.item.id)">
                  <feather-icon
                    icon="TrashIcon"
                    class="text-danger"
                  />
                  رد کردن
                </b-dropdown-item>
              </b-dropdown>
            </template>

          </b-table>
          <b-pagination
            v-model="currentPage"
            class="mt-2"
            :total-rows="totalRows"
            :per-page="perPage"
          />
        </div>
      </b-overlay>

      <b-modal
          ref="submitProject"
          v-model="showDetail"
          ok-title="بستن"
          ok-only
      >
        <dl v-if="showDetail">
          <dt ><b>نام اتاق</b></dt>
          <dd >{{ detail.room ? detail.room.name : 'فرقی ندارد'  }}</dd>
          <dt><b>تاریخ رزرو</b></dt>
          <dd><bdi>{{ detail.start_at_jalali }} الی {{ detail.end_at_jalali }}</bdi></dd>
          <dt><b>وضعیت</b></dt>
          <dd><b-badge
              :variant="detail.status.label"
              class="mr-1"
          >
            {{ detail.status.title }}
          </b-badge>
          </dd>
          <dt v-if="detail.description"><b>توضیحات</b></dt>
          <dd v-if="detail.description" v-html="detail.description"></dd>
          <dt><b>تاریخ درخواست</b></dt>
          <dd>
            {{ detail.createdAt }}
          </dd>
          <dt v-if="detail.action_at"><b>تاریخ رد/تأیید</b></dt>
          <dd>
            {{ detail.action_at }}
          </dd>
          <dt v-if="detail.admin_description"><b>توضیحات مدیر</b></dt>
          <dd v-html="detail.admin_description"></dd>
        </dl>
      </b-modal>

    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BTable,
  BSpinner,
  BBadge,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BPagination,
  BFormInput,
  BCollapse,
  BFormGroup,
  BButton,
  VBToggle,
  BAvatar,
  BFormInvalidFeedback,
  BForm,
  BModal,
  BFormRadio,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import {ValidationProvider} from "vee-validate";
import { debounce } from '@/libs/debounce'
import { doubleRaf, queryString } from '@/libs/utils'

export default {
  name: 'Room_List',
  components: {
    BFormRadio,
    ValidationProvider, BModal, BForm, BFormInvalidFeedback,
    BAvatar,
    BButton,
    VSelect,
    BFormGroup,
    BCollapse,
    BFormInput,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BTable,
    BSpinner,
    BBadge,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BPagination,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'شناسه',
        },
        {
          key: 'room.name',
          label: 'نام اتاق',
        },
        {
          key: 'date',
          label: 'ساعت رزرو',
        },
        {
          key: 'creator.name',
          label: 'درخواست دهنده',
        },
        {
          key: 'status',
          label: 'وضعیت',
        },
        {
          key: 'action',
          label: 'عملیات',
        },
      ],
      items: [],
      currentPage: 1,
      totalRows: 0,
      perPage: 0,
      onProgress: true,
      showDetail:false,
      detail : {},
      search: {},
      roomList : [],
      receiversList: [],
      getReceivers: false,
    }
  },
  computed: {
    exportExcel() {
      const query = queryString(this.search)
      return `${process.env.VUE_APP_API}room-reservations?export-excel=1&${query}`
    },
  },
  mounted() {
    this.getRoomList()
    this.getRooms()
    this.setSearchData()
  },
  methods: {
    getRoomList() {
      this.onProgress = true
      const currentQuery = JSON.parse(JSON.stringify(this.$route.query))

      this.$http.get('room-reservations', {
        params: {
          ...currentQuery,
          ...this.search,
          page: this.currentPage,
        },
      })
        .then(({ data }) => {
          if (data.status) {
            this.items = data.rooms
            this.currentPage = data.meta.current_page
            this.totalRows = data.meta.total
            this.perPage = data.meta.per_page
          } else {
            this.$bvToast.toast(data.message ?? 'در دریافت لیست اتاق جلسات خطایی رخ داده', {
              title: 'حطا',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          }
        })
        .catch(error => {
          this.$bvToast.toast(error.response.data.message, {
            title: 'خطا در دریافت اطلاعات',
            toaster: 'b-toaster-top-right',
            variant: 'danger',
          })
        })
        .finally(() => {
          this.onProgress = false
        })
    },
    deleteRequest(id) {
      this.$swal({
        title: 'حذف درخواست ',
        text: 'آیا از حذف رزرو اتاق جلسه مطمئن هستید؟',
        icon: 'question',
        showCancelButton: true,
        cancelButtonText: 'لغو حذف',
        confirmButtonText: 'حذف درخواست',
        customClass: {
          confirmButton: 'btn btn-danger mr-2',
          cancelButton: 'btn btn-success',
        },
      })
          .then(async result => {
            if (result.value) {
              this.$swal({
                title: 'در حال انجام',
                text: 'لطفا تا دریافت نتیجه منتظر بمانید',
                icon: 'info',
                confirmButtonText: 'متوجه شدم',
              })
              await this.$http.put(`room-reservations/${id}/cancel`)
                  .then(({data}) => {
                    if (data.status) {
                      this.$swal({
                        title: 'حذف شد',
                        text: 'حذف درخواست  با موفقیت انجام شد',
                        icon: 'success',
                        confirmButtonText: 'متوجه شدم',
                        timer: 2000,
                      })
                      this.getRoomList()
                    } else {
                      this.$swal({
                        title: 'حذف انجام نشد',
                        text: data.message ?? 'ارتباط با وبسرویس انجام نشد',
                        icon: 'error',
                        confirmButtonText: 'متوجه شدم',
                        timer: 4000,
                      })
                    }
                  })
                  .catch(error => {
                    this.$swal({
                      title: 'حذف انجام نشد',
                      text: error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد',
                      icon: 'error',
                      confirmButtonText: 'متوجه شدم',
                      timer: 4000,
                    })

                  })
            }
          })
    },
    getDetail(id){
      this.$http.get(`room-reservations/${id}`)
          .then(({ data }) => {
            if (data.status) {
              this.detail = data.reservation
              this.showDetail = true
            } else {
              this.$bvToast.toast(data.message ?? 'در دریافت جزییات رزرو اتاق جلسات خطایی رخ داده', {
                title: 'حطا',
                toaster: 'b-toaster-top-right',
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, {
              title: 'خطا در دریافت اطلاعات',
              toaster: 'b-toaster-top-right',
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })

    },
    getRooms() {
      this.$http.get('rooms/for-select')
          .then(({data}) => {
            this.roomList = data
            this.roomList.unshift({
              'id' : 0,
              'name' : 'فرقی نمی کند',
              'description' : 'مسئول اتاق جلسات با توجه به شرایط اتاق جلسات تصمیم گیری می نماید. '
            })
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
    },
    advanceSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {
          ...this.search,
        },
      })
          .then(() => {
            this.getRoomList()
          })
          .catch(() => {
          })

      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    clearSearch() {
      this.$router.replace({
        name: this.$route.name,
        query: {},
      })
          .then(() => {
            this.getRoomList()
          })
          .catch(() => {
          })

      this.search = {}
      doubleRaf(() => {
        this.$refs.resultTable.scrollIntoView({ behavior: 'smooth' })
      })
    },
    setSearchData() {
      doubleRaf(() => {
        this.search = JSON.parse(JSON.stringify(this.$route.query))
      })
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true)
        this.searchUser(loading, search, this)
      }
    },
    searchUser: debounce((loading, search, vm) => {
      vm.getRelatedUsers(search)
      loading(false)
    }, 400),
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$router.push({
          name: 'Room_Update',
          query: { page: this.currentPage },
        })
        this.items = []
        this.getRoomList()
      }
    },
  },
}
</script>

<style>

</style>
